'use strict';

(function ($, Drupal) {

  /**
   * Implements Ajax for Search Results in Product Specification.
   *
   * @type {{attach: attach}}
   */
  Drupal.behaviors.searchResultPagination = {
    attach: function attach(context) {
      Drupal.behaviors.searchResultPagination.bind(context);
    },

    /**
     * Bind pagination.
     *
     * @param context
     *   Affected piece of HTML.
     */
    bind: function bind(context) {
      var pagerSelector = '.product-specification-pager';
      $(pagerSelector, context).find('a').on('click', function (e) {
        var $this = $(e.currentTarget);
        Drupal.behaviors.searchResultPagination.paginate(context, $this);
        return false;
      });
    },

    /**
     * Update pager after ajax complete.
     *
     * @param context
     *   Affected piece of HTML.
     * @param pager
     *   Pager element
     */
    updatePager: function updatePager(context, pager) {
      var pagerSelector = '.product-specification-pager';
      $(pagerSelector, context).html(pager);
    },

    /**
     * Do the pagination.
     *
     * @param context
     *   Affected piece of HTML.
     * @param $link
     *   Link
     */
    paginate: function paginate(context, $link) {
      var loadingClass = 'loading';
      var pagerSelector = '.product-specification-pager';
      var regionSelector = $(pagerSelector, context).data('content');

      var ajaxUrl = window.location.pathname + '/pager' + $link.attr('href');
      var urlWithParams = '' + window.location.pathname + $link.attr('href');

      $('html, body').stop().animate({ scrollTop: 0 }, 500, 'swing');

      $(regionSelector).addClass(loadingClass);

      $.ajax({
        url: ajaxUrl,
        context: context,
        contentType: "application/json",
        dataType: "json",
        cache: true
      }).done(function (data) {

        $(regionSelector).html(data.json_results).removeClass(loadingClass);

        Drupal.behaviors.searchResultPagination.updatePager(context, data.pager);
        Drupal.behaviors.searchResultPagination.bind(context);

        if (history.pushState) {
          var newUrl = window.location.protocol + '//' + window.location.host + urlWithParams;
          window.history.pushState({ path: newUrl }, '', newUrl);
        }

        Drupal.behaviors.svgConvert.convert();

        // Sets table paging position.
        Drupal.behaviors.paginationPosition.pagPosition();
      });
    }

  };
})(jQuery, Drupal);
